/* Used global Wordpress php variables to the ajax requests */
/* global phpvars */
/* global Swiper */
/* global GLightbox */

/**
 * Opens a popup.
 */
export const popupOpen = () => {

	const btnPeoplePopup = document.querySelectorAll( '.js-people-popup' );
	if ( btnPeoplePopup ) {

		btnPeoplePopup.forEach( ( btn ) => {

			btn.addEventListener( 'click', function () {

				btn.classList.add( 'load' );

				const peopleId = btn.getAttribute( 'data-id' );

				const data = new FormData();
				data.append( 'action', 'popup_people' );
				data.append( 'security', phpvars.security );
				data.append( 'peopleId', peopleId );

				fetch( `${phpvars.ajax_url}`, {
					method: 'POST',
					credentials: 'same-origin',
					body: data,
				} )
					.then( ( res ) => res.text() )
					.then( ( dataReturn ) => {

						const popup = document.querySelector( '.popup-people' );
						if ( popup ) {
							popup.remove();
						}

						btn.classList.remove( 'load' );

						dataReturn = JSON.parse( dataReturn );
						if (
							typeof dataReturn.success !== 'undefined' &&
							dataReturn.success === true
						) {

							document.body.classList.add( 'is-popup' );

							const popup = document.createElement( 'div' );
							popup.classList.add(
								'popup',
								'popup-people',
								'is-active'
							);

							popup.innerHTML = dataReturn.data.html;
							document.body.appendChild( popup );

							popupNavigation();
							popupOpen();
							GLightbox( {} );

						}

					} )

			} );

		} );

	}

};
/**
 * Popup nav
 */
const popupNavigation = () => {

	const popup = document.querySelector( '.popup-people' );

	// Popup

	const close = document.querySelector( '.popup-people__close' );
	if ( close ) {

		close.addEventListener( 'click', function () {

			popup.remove();

			document.body.classList.remove( 'is-popup' );

		} );

	}

	// Swiper

	const swiperPeople = new Swiper( '.popup-people .swiper', {
		//speed: 400,
		slidesPerView: 1,
		watchActiveIndex: true,
		navigation: {
			prevEl: '.popup-people__slider-prev',
			nextEl: '.popup-people__slider-next',
		},
	} );

	const backSwiperPeople = document.querySelector(
		'.popup-people__slider-back:not(.disabled)'
	);
	if ( backSwiperPeople ) {

		backSwiperPeople.addEventListener( 'click', function () {

			if ( swiperPeople.activeIndex > 0 ) {

				swiperPeople.slideTo( swiperPeople.activeIndex - 1 );

			} else {

				popup.remove();

				document.body.classList.remove( 'is-popup' );
			}

		} );

	}

	const btnSwiperPeople = document.querySelectorAll(
		'.popup-people__slider-btn'
	);
	if ( btnSwiperPeople ) {

		btnSwiperPeople.forEach( ( btn ) => {

			btn.addEventListener( 'click', function () {

				btnSwiperPeople.forEach( function ( element ) {

					element.classList.remove( 'is-active' );

				} );
				btn.classList.add( 'is-active' );

				const index = btn.getAttribute( 'data-id' );
				swiperPeople.slideTo( index );

			} );

		} );

	}

	swiperPeople.on( 'slideChangeTransitionEnd', function ( swiper ) {

		let id = swiper.activeIndex;
		if ( id === swiper.slides.length - 1 ) {

			id = 'form';

		}
		popup.setAttribute( 'data-id', id );

		btnSwiperPeople.forEach( function ( element ) {

			element.classList.remove( 'is-active' );

			if ( element.getAttribute( 'data-id' ) === swiper.activeIndex ) {

				element.classList.add( 'is-active' );

			}

		} );

	} );

};
